'use strict';

var ngModule = 'frontend.performanceReview.invite';

require('angular')
  .module(ngModule, [])
  .component('performanceReviewInvite', require('./performance-review-invite'))
  .component('performanceReviewInviteImport', require('./performance-review-invite-import'));

module.exports = ngModule;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-invite/index.js
 ** module id = 246
 ** module chunks = 0
 **/